import { render, staticRenderFns } from "./MuestreoAceite.vue?vue&type=template&id=5b4b570f&scoped=true"
import script from "./MuestreoAceite.vue?vue&type=script&lang=js"
export * from "./MuestreoAceite.vue?vue&type=script&lang=js"
import style0 from "./MuestreoAceite.vue?vue&type=style&index=0&id=5b4b570f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4b570f",
  null
  
)

export default component.exports